import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { hideSnackBar } from './store/actions';
import './index.scss';
function Alert(props: any) {
  return <MuiAlert elevation={24} variant="filled" {...props} />;
}
const vertical = 'top';
const horizontal = 'right';

const SnackBar: FunctionComponent<any> = () => {
  const dispatch = useDispatch();

  const resetSnackbar = useCallback(() => dispatch(hideSnackBar([])), [dispatch]);

  const snackbarState: any = useSelector((state: any) => state.snackBar);
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={snackbarState.show}
      autoHideDuration={3000}
      onClose={() => resetSnackbar()}
      className="snackbar"
    >
      <Alert onClose={() => resetSnackbar()} severity={snackbarState.variant}>
        {snackbarState.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
